{
  "iframeWaitingMessage": "お待ちいただきありがとうございます。あと少しお待ちください...",
  "solutionIframe": "メインコンテンツ"
}
